const getEUCountryListwithID = ():{id:number, value:string}[] => {
    const country = [
        {id:15, value:"AT" }, //Austria
        {id:3, value:"AL" }, //Albania
        {id:6, value:"AD" }, //Andorra
        {id:12, value:"AM" }, //Armenia
        {id:16, value:"AZ" }, //Azerbaijan
        {id:22, value:"BE" }, //Belgium
        {id:29, value:"BA" }, //Bosnia and Herzegovina
        {id:21, value:"BY" }, //Belarus
        {id:35, value:"BG" }, //Bulgaria
        {id:56, value:"HR" }, //Croatia
        {id:59, value:"CY" }, //Cyprus
        {id:60, value:"CZ" }, //Czechia
        {id:61, value:"DK" }, //Denmark
        {id:70, value:"EE" }, //Estonia
        {id:73, value:"FO" }, //Faroe Islands
        {id:75, value:"FI" }, //Finland
        {id:76, value:"FR" }, //France
        {id:83, value:"DE" }, //Germany
        {id:85, value:"GI" }, //Gibraltar
        {id:86, value:"GR" }, //Greece
        {id:82, value:"GE" }, //Georgia
        {id:103, value:"HU" }, //Hungary
        {id:107, value:"IE" }, //Ireland
        {id:102, value:"IS" }, //Iceland
        {id:110, value:"IT" }, //Italy
        {id:123, value:"LV" }, //Latvia
        {id:129, value:"LT" }, //Lithuania
        {id:128, value:"LI" }, //Liechtenstein
        {id:115, value:"KZ" }, //Kazakhstan
        {id:0, value:"XK" }, //Kosovo
        {id:130, value:"LU" }, //Luxembourg
        {id:138, value:"MT" }, //Malta
        {id:146, value:"MD" }, //Moldova
        {id:147, value:"MC" }, //Monaco
        {id:149, value:"ME" }, //Montenegro
        {id:157, value:"NL" }, //Netherlands
        {id:132, value:"MK" }, //North Macedonia
        {id:166, value:"NO" }, //Norway
        {id:177, value:"PL" }, //Poland
        {id:178, value:"PT" }, //Portugal
        {id:182, value:"RO" }, //Romania
        {id:183, value:"RU" }, //Russia
        {id:193, value:"SM" }, //San Marino
        {id:202, value:"SK" }, //Slovakia
        {id:197, value:"RS" }, //Serbia
        {id:203, value:"SI" }, //Slovenia
        {id:209, value:"ES" }, //Spain
        {id:215, value:"SE" }, //Sweden
        {id:216, value:"CH" }, //Switzerland
        {id:228, value:"TR" }, //Turkey
        {id:233, value:"UA" }, //Ukraine
        {id:98, value:"VA" } //Vatican City
    ];

    return country;
}

export default getEUCountryListwithID